import { SearchesModel } from '../models/platform/searchesModel';
import SearchApi from '../api/platform/searchApi';
import { handleError, mapUnknownErrorToSystemError, mapResponseErrorToSystemError } from '../utils/errorUtils';
import { ResponseErrorModel } from '../models/system/responseErrorModel';

interface SaveSearchParams {
    searchName: string;
    searchCriteria: any;
    editedSearch?: SearchesModel | null;
    shouldExecuteAfterSave?: boolean;
    setIsSaveModalOpen: (isOpen: boolean) => void;
    onRequestClose: (savedSearch: SearchesModel, wasSaved: boolean, executeAfterSave: boolean, isNew: boolean) => void;
    triggerSystemError: (error: any) => void;
}


export const saveSearch = async ({
    searchName,
    searchCriteria,
    editedSearch,
    shouldExecuteAfterSave = false,
    setIsSaveModalOpen,
    onRequestClose,
    triggerSystemError,
}: SaveSearchParams): Promise<void> => {
    try {
        if (!searchCriteria) {
            throw new Error('Invalid search criteria');
        }

        const searchPayload: SearchesModel = {
            _id: editedSearch?._id ?? undefined,
            search_name: searchName,
            search_criteria: searchCriteria,
        };

        let response;
        if (editedSearch && editedSearch._id) {
            response = await SearchApi.updateSearch(editedSearch._id, searchPayload);
        } else {
            response = await SearchApi.createSearch(searchPayload);
        }

        if (response.success) {
            const savedSearch = response.data as SearchesModel;
            onRequestClose(savedSearch, true, shouldExecuteAfterSave, true);
        } else {
            throw response as ResponseErrorModel;
        }
    } catch (error) {
        handleError(mapUnknownErrorToSystemError(error, false), null,
            (occurred: boolean) => {
                if (occurred) {
                    console.error('An error occurred during saveSearch.');
                }
            }, triggerSystemError);
    } finally {
        setIsSaveModalOpen(false);
    }
};
